// common
export const GET_INITIAL = 'GET_INITIAL'

// user
export const LOGIN_IN = 'LOGIN_IN'
export const EXIT_LOGIN = 'EXIT_LOGIN'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js